import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";

export interface IChoiceControllerOptions {
    type: string;
    onClick: () => void;
    selected: boolean;
}

export class ChoiceController extends AnimationBaseController {
    $model: any;

    private selected: boolean = false;

    public constructor(@Inject private _options: IChoiceControllerOptions) {
        super("ChoiceController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            onPointerDown: () => {
                this.select();
                this.gotoAndStop(`${this._options.type}_press + focus frame initialize`);

                this._options.onClick();
            },
            onPointerUp: () => {
                if (this.selected) {
                    this.gotoAndStop(`hover + ${this._options.type} focus`);
                } else {
                    this.gotoAndStop("active");
                }
            },
            onPointerOut: () => {
                if (this.selected) {
                    this.gotoAndStop(`active + ${this._options.type} focus`);
                } else {
                    this.gotoAndStop("active");
                }
            },
            onPointerOver: () => {
                if (this.selected) {
                    this.gotoAndStop(`hover + ${this._options.type} focus`);
                } else {
                    this.gotoAndStop(`hover`);
                }
            }
        };
    }

    protected onInitialize(): void {
        if (this._options.selected) {
            this.gotoAndStop(`hover + ${this._options.type} focus`);
        } else {
            this.gotoAndStop("active");
        }
    }

    public unselect(): void {
        this.selected = false;
        this.gotoAndStop("active");
    }

    public select(): void {
        this.selected = true;
    }
}
